import { useDispatch } from "react-redux";
import { setActiveProject } from "../../store";

function ProjectInfoView({ title, desc }) {
  const dispatch = useDispatch();
  return (
    <div className="h-full w-screen fixed top-0 left-0 z-30 flex flex-col items-center">
      <div className="text-white w-full h-[80%] pt-2 px-2 flex flex-col">
        <div className="mb-1 text-lg text-center">{title}</div>
        <div className="w-full grow overflow-y-auto thin-scrollbar">{desc}</div>
      </div>
      <div className="grow"></div>
      <button
        className="h-max my-1 px-3 py-0.5 select-none active:shadow-none w-max rounded text-center bg-black cyan-text pxs-button-shadow"
        type="button"
        onClick={() => {
          dispatch(setActiveProject(null));
        }}
      >
        <p className="text-sm">Back</p>
      </button>
      <div className="grow"></div>
    </div>
  );
}

export default ProjectInfoView;
